import axios from "./axios";

export const getClients = async () => {
    const response = await axios.get("/api/users/clients/");
    return response.data;
};

export const createClients = async (payload) => {
    const response = await axios.post("/api/users/clients/", payload);
    return response.data;
};

export const editClients = async (id, payload) => {
    const response = await axios.put(`/api/users/clients/${id}/`, payload);
    return response.data;
};

export const deleteClients = async (id) => {
    const response = await axios.delete(`/api/users/clients/${id}/`);
    return response.data;
};

export const generateToken = async (id) => {
    const response = await axios.post(`/api/broker-gateway/clients/${id}/generate-token/`);
    return response.data;
};
